// extracted by mini-css-extract-plugin
export default {"links":"profile-menu_links__sIzrv","navlink":"profile-menu_navlink__230DF","selected":"profile-menu_selected__bpPYY"};